import './steelehillresorts2/style';
import FormStructure from './steelehillresorts2/form_structure';

export default FormStructure;